import React from "react";
import { ButtonWithIcon } from "../button";
import { Close } from "../icons";
import { H3 } from "../Typography";

const ModalHeader = ({ children, onHide }) => {
  return (
    <div className="modal-header">
      <H3 className="heading">{children}</H3>
      {onHide && (
        <ButtonWithIcon
          size="md"
          icon={Close}
          onClick={onHide}
          className="close-button"
        />
      )}
    </div>
  );
};

export default ModalHeader;
